import React, { useEffect, useState } from "react";
import PopupModal from "../../Components/ModalComponent/PopupModal";
import InputComponent from "../../Components/InputComponent/InputComponent";
import AlertBox from "../../Components/AlertBox/AlertBox";
import DataTable from "../../Components/DataTable/DataTable";
import { Message, Popconfirm, } from "@arco-design/web-react";
import { ManageApis } from "../../AppServices/ManageApi";
import Loader from "../../Components/LoaderComponent/Loader";
import { Button } from "react-bootstrap";
import { UNSAFE_useScrollRestoration, useNavigate } from "react-router-dom";
import { convertUtcToBrowserTimeZone } from "../../Functions/Utils";

let totalItem;

function ServicesKey({ mn }) {
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const initialVisibleValue = { show: false, type: "" }
  const initialAlertValue = { message: '', show: false, enableSuccessIcon: false, enableFailIcon: false }
  const [serviceKeyTableData, setServiceKeyTableData] = useState([])
  const [loader, setloader] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [Total, setTotal] = useState();
  const [rowData, setRowData] = useState({});
  const [clientsNameList, setClientsNameList] = useState([]);
  const [serviceNameList, setServiceNameList] = useState([]);
  const [visible, setvisible] = useState(initialVisibleValue);
  const [alertData, setAlertData] = useState(initialAlertValue);
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [currentServiceId, setCurrentServiceId] = useState('')
  const [currentClientId, setcurrentClientId] = useState('')
  const [buttonDisabled, setButtonDisabled] = useState(
    {
      ok: true,
      generate: false
    }
  )
  const [postParam, setpostParam] = useState({
    clientId: '',
    serviceId: '',
    key: ''
  })
  const columns = [
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },

    {
      title: "Client Name ",
      dataIndex: "clientName",
      key: "cname",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "Created Date",
      dataIndex: "formattedCreateDate",
      key: "formattedCreateDate",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
      render: (v, record) => {
        return (<div>{convertUtcToBrowserTimeZone(record.formattedCreateDate)}</div>)
      }
    },
    {
      title: "Key",
      key: "key",
      dataIndex: "key",
      render: (text, record) => [
        <a key="editable">
          <i
            class="far fa-copy cursor-pointer px_hover_1 font_18 text_master"
            onClick={() => handleCopyKey(record.key)}
          ></i>
        </a>,
      ],
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "status",
      dataIndex: "keyStatus",
      key: "keyStatus",
      render: (status) => (
        <>
          {
            <span
              className={`badge ${status == "Active"
                ? "badge_success_soft"
                : "badge-warning badge_danger_soft"
                } font_12 fw_500 rounded-pill`}
            >
              {status}
            </span>
          }
        </>
      ),
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },

    {
      title: "Action",


      render: (text, record) => [
        <a key="editable">
          <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100" on onClick={() => handleEditRow('edit', record)}>
            Edit
          </button>
        </a>,
      ],
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
      width: "100px",
    },
  ];



  useEffect(() => {
    getServiceKeyDataList()
    getClientsListData()
    getServiceListDetails()
  }, [])

  // client list function
  const getClientsListData = async () => {
    try {

      let response = await ManageApis("get", global.getClientsList);
      //console.log(response);

      if (response.message === "Success") {
        setcurrentClientId(response?.response_data[0]?.id)
        //console.log('first client =>', response?.response_data[0]?.id)
        setClientsNameList(response?.response_data.map(row => ({
          name: row.name,
          id: row.id,
        })));

      } else {
        //console.log(response)
        Message.error(response?.message)
      }
    } catch (error) {

      //console.log(error)
    }
  };
  // service list function
  const getServiceListDetails = async () => {
    try {

      let response = await ManageApis("get", global.getServiceList);
      //console.log(response);

      if (response.message === "Success") {
        //console.log('first serviceid =>', response?.response_data[0]?.id)
        setCurrentServiceId(response?.response_data[0]?.id)
        setServiceNameList(response?.response_data.map(row => ({
          name: row.name,
          id: row.id,


        })))
      } else {
        //console.log(response)
        Message.error(response?.message)
      }
    } catch (error) {

      //console.log(error);
    }
  };


  const getServiceKeyDataList = async (current = 1) => {
    try {
      setloader(true)
      const param = `currentPage=${current}&itemPerPage=${10}`
      let response = await ManageApis("get", global.getServiceKeyTableData, param)
      //console.log(response)
      if (response.message === "Success") {
        setloader(false)
        //console.log(response.response_data)
        setServiceKeyTableData(response?.response_data?.data)
        totalItem = response?.response_data?.totalRecords
      } else {
        setloader(false)
        Message.error("Something went wrong")
        //console.log(response?.message.toString())
      }



    } catch (error) {
      setloader(false)
    }
  }

  const handleEditRow = (type, record) => {
    setButtonDisabled(prev => ({ ...prev, ok: true }))
    setButtonDisabled(prev => ({ ...prev, generate: false }))
    if (type == 'edit') {
      //console.log(record)
      setRowData(record)
    }
    setvisible((pre) => ({ show: true, type }))

    if (type == 'create') {
      setRowData({})
    }
  }

  useEffect(() => {
    //console.log({ rowData })
  }, [rowData])

  let isEmpty = false

  const handleCopyKey = (key) => {
    //console.log(key)
    navigator.clipboard.writeText(key)
    Message.success("Key copied successfully")
  }

  const handleActive_Detactivate = async () => {
    try {
      setloader(true)
      const param = `ClientServiceKeyId=${rowData.id}`
      const changedkeyStatus = rowData.keyStatus === "Active" ? 'Deactivated' : 'Activated';
      let url = rowData.keyStatus === "Active" ? global.deActivateKey + param : global.activateKey + param
      let response = await ManageApis("post", url,)
      if (response.message === "Success") {
        //console.log(response)
        setloader(false)
        setvisible(initialVisibleValue)
        Message.success(`Key ${changedkeyStatus} Succcessfully`)
        getServiceKeyDataList()

        // setTimeout(() => { window.location.href = '/ServicesKey' }, 1000)
      } else {
        //console.log(response)
      }

    } catch (error) {
      //console.log(error)

    }
  }

  const handleModalClose = () => {
    setvisible(initialVisibleValue);
    // setRowData({})
  }




  const changedServiceid = (event) => {
    setCurrentServiceId(event.target.value)
    //console.log(currentServiceId)
  }

  const changedClientid = (e) => {
    setcurrentClientId(e.target.value)
    //console.log(currentClientId)
  }
  const handleGeneratekey = async () => {
    // ""
    const param = `ClientId=${currentClientId}&ServiceId=${currentServiceId}`
    let response = await ManageApis("get", global.generateKey, param)
    if (response?.message === "Success") {
      //console.log(response)
      Message.success("Key Generated Successfully")
      setButtonDisabled(prev => ({ ...prev, ok: false, generate: true }))

      setpostParam({ clientId: currentClientId, serviceId: currentServiceId, key: response.response_data.token })
    } else {
      Message.error('Key Generation Failed')
      //console.log(response)
      setButtonDisabled(true)
    }
  }

  const handleSubmitKey = async () => {
    setloader(true)
    let secondresponse = await ManageApis("post", global.addServiceToClient, postParam)
    if (secondresponse.message === "Success") {
      setloader(false)
      setvisible(initialVisibleValue)
      Message.success("Service Key Added Successfully")
      getServiceKeyDataList()

      // setTimeout(() => { window.location.href = '/ServicesKey' }, 1000)

    }
    else {
      setloader(false)
      setvisible(initialVisibleValue)
      Message.error("Something Went Wrong")
    }
  }
  function onChangeTable(pagination) {
    // setcurrentPage(currentPage + 1)
    //console.log(pagination);
    setServiceKeyTableData([])
    const { current, pageSize } = pagination;
    //console.log("sadsadsadas=====>", current)
    setcurrentPage(current)
    setTableLoader(true);
    getServiceKeyDataList(current)

    // setServiceKeyTableData(dataTableInitialLoader(columns));



    setTableLoader(false);

  }

  return (
    <>
      {<AlertBox show={alertData.show} message={alertData.message} handlecancel={() => setAlertData(initialAlertValue)} />}
      {loader && <Loader />}
      <div className="px-3">
        <div className="mb-3">
          <div className="align-items-center d-flex justify-content-between flex-wrap">
            <div className="col col-sm d-flex pt-2">
              <h3 className="fw_600 font_18 text_master2 ms-2 mb-0">
                Services Key
              </h3>
            </div>
            <div className="col-auto col-sm-auto pt-2">
              <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={() => handleEditRow('create')}>
                Add Services Key
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="table_type02 table-responsive custom_scroll1 d-none">
            <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
              <thead className="bg_master2 text-white">
                <tr>
                  <th className="fw_500">Service Name</th>
                  <th className="fw_500">Client Name</th>
                  <th className="fw_500">Created Date</th>
                  <th className="fw_500">Key</th>
                  <th className="fw_500">Status</th>
                  <th className="fw_500 w_100x">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Passport OCR</td>
                  <td>TestGokul</td>
                  <td>2023/08/26</td>
                  <td>
                    <i className="far fa-copy cursor-pointer px_hover_1 font_18 text_master"></i>
                  </td>
                  <td>
                    <span className="badge badge-warning badge_danger_soft font_12 fw_500 rounded-pill">
                      Inactive
                    </span>
                    {/* <span className="badge badge-warning badge_success_soft font_12 fw_500 rounded-pill">Active</span> */}
                  </td>
                  <td>
                    <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Passport OCR</td>
                  <td>TestGokul</td>
                  <td>2023/08/26</td>
                  <td>
                    <i className="far fa-copy cursor-pointer px_hover_1 font_18 text_master"></i>
                  </td>
                  <td>
                    <span className="badge badge-warning badge_danger_soft font_12 fw_500 rounded-pill">
                      Inactive
                    </span>
                  </td>
                  <td>
                    <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Passport OCR</td>
                  <td>TestGokul</td>
                  <td>2023/08/26</td>
                  <td>
                    <i className="far fa-copy cursor-pointer px_hover_1 font_18 text_master"></i>
                  </td>
                  <td>
                    <span className="badge badge-warning badge_danger_soft font_12 fw_500 rounded-pill">
                      Inactive
                    </span>
                  </td>
                  <td>
                    <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Passport OCR</td>
                  <td>TestGokul</td>
                  <td>2023/08/26</td>
                  <td>
                    <i className="far fa-copy cursor-pointer px_hover_1 font_18 text_master"></i>
                  </td>
                  <td>
                    <span className="badge badge-warning badge_danger_soft font_12 fw_500 rounded-pill">
                      Inactive
                    </span>
                  </td>
                  <td>
                    <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Passport OCR</td>
                  <td>TestGokul</td>
                  <td>2023/08/26</td>
                  <td>
                    <i className="far fa-copy cursor-pointer px_hover_1 font_18 text_master"></i>
                  </td>
                  <td>
                    <span className="badge badge-warning badge_danger_soft font_12 fw_500 rounded-pill">
                      Inactive
                    </span>
                  </td>
                  <td>
                    <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <DataTable
            columnData={columns}
            rowData={serviceKeyTableData}
            current={currentPage}
            total={totalItem}
            onChangeTable={onChangeTable}
          />
        </div>
      </div>

      {/* <PopupModal title="Add Service Key" size="md">
        <div>
          <div className="mb-3">
            <label className="mb-0 pb_2x text_master2 fw_500 font_14">
            Client<span className="text-danger">*</span>
            </label>
            <select className="form-control rounded font_12">
              <option>test</option>
              <option>test</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="mb-0 pb_2x text_master2 fw_500 font_14">
            Service Name<span className="text-danger">*</span>
            </label>
            <select className="form-control rounded font_12">
              <option>test</option>
              <option>test</option>
            </select>
          </div>
          <div>
            <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100">Generate Key</button>
          </div>
          <div className="border-top pt-3 mt-3 d-flex gap-2">
            <button className="btn px_btn btn-master-line px-4 rounded fw_500 font_12 w-100">Cancel</button>
            <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100">Ok</button>
          </div>
        </div>
      </PopupModal> */}

      <PopupModal visible={visible.show} title={visible.type == 'edit' ? "Edit Service Key" : "Add Service Key"} size="md" handleClose={handleModalClose}>
        <div>
          <div className="mb-3">
            <label className="mb-0 pb_2x text_master2 fw_500 font_14">
              Client<span className="text-danger">*</span>
            </label>
            <select className="form-select rounded font_12" onChange={changedClientid} disabled={visible.type == "edit"} value={rowData?.clientId}>


              {clientsNameList?.map((itm) => (
                <option key={itm.id} value={itm.id}>{itm.name}</option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label className="mb-0 pb_2x text_master2 fw_500 font_14">
              Service Name<span className="text-danger">*</span>
            </label>
            <select className="form-select rounded font_12" onChange={changedServiceid} disabled={visible.type == "edit"} value={rowData?.serviceId}>
              {serviceNameList?.map((itm) => (
                <option value={itm.id}>{itm.name}</option>
              ))}
            </select>
          </div>
          <div className="d-flex gap-2">
            {/*  */}
            {isEmpty = Object.keys(rowData).length === 0}
            {isEmpty ?
              <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={handleGeneratekey} disabled={buttonDisabled.generate}>
                Generate key
              </button>
              :
              <>
                <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={() => { setAlertData((pre) => ({ ...pre, show: true, message: rowData.key })); setvisible(initialVisibleValue) }}>
                  View Key
                </button>
                <Popconfirm
                  title={`sure want to change ${rowData?.keyStatus === "Active" ? "Deactivate" : "Activate"}`}
                  style={{ zIndex: 1064 }}
                  onOk={handleActive_Detactivate}
                >
                  <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100">
                    {rowData?.keyStatus === "Active" ? "Deactivate" : "Activate"}
                  </button>
                </Popconfirm>
              </>
            }
          </div>
          <div className="border-top pt-3 mt-3 d-flex gap-2">
            <button className="btn px_btn btn-master-line px-4 rounded fw_500 font_12 w-100" onClick={() => setvisible(initialVisibleValue)}>
              Cancel
            </button>
            {visible.type !== "edit" && <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" disabled={buttonDisabled.ok} onClick={handleSubmitKey}>
              Ok
            </button>}
          </div>
        </div>

      </PopupModal>
    </>
  );
}

export default ServicesKey;
